const AUTH_CODE_EXCHANGE_KEY = '__jupiterAuthCodeExchange__';

/**
 * Single-flight guard for the Auth0 authorization-code exchange.
 *
 * When the legacy (`@peloton/auth`) and new (`@auth/oauth`) providers are
 * dual-mounted during the auth migration, both observe the `?code=&state=`
 * callback params and would each call `handleRedirectCallback()`. The code is
 * single-use, so the second exchange fails with `invalid_grant`. Memoizing the
 * in-flight promise on `window` ensures only ONE client consumes the code; the
 * other provider awaits the same result.
 *
 * Remove once the legacy provider is gone and only one provider mounts.
 */
export const exchangeAuthorizationCodeOnce = <T>(
  exchange: () => Promise<T>,
): Promise<T> => {
  const w = window as unknown as {
    __jupiterAuthCodeExchange__?: Promise<unknown>;
  };
  if (!w[AUTH_CODE_EXCHANGE_KEY]) {
    w[AUTH_CODE_EXCHANGE_KEY] = exchange();
  }
  return w[AUTH_CODE_EXCHANGE_KEY] as Promise<T>;
};
